// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__30bBX","savePackageButton":"ClientWallet_savePackageButton__2PB3q"};